import React, { Component } from "react";
import Card from "../../components/Card";
import Modal from "react-bootstrap/Modal";
import { toast } from "react-toastify";
import Backend from "../../../utils/Backend"; // ✅ add this

export default class NotificationConsole extends Component {
  constructor(props) {
    super(props);
    this.state = {
      notification: {
        title: "",
        message: "",
        userType: "Customers",
        filters: {
          county: "All",
          status: "Active",
          lastOrderDate: "",
          isHighValue: false,
          activeDeliveries: false,
        },
      },
      targetedUsers: 0,
      showConfirmModal: false,
      isSending: false,
      isLoadingAudience: false,
      aiSuggestion: {
        title: "Craving a cold one?",
        message: "Free delivery on all orders above €30 this weekend! 🍻",
        audience: "Active customers",
        bestTime: "Friday, 18:00",
      },
    };
  }

  _handleInputChange = (e) => {
    const { name, value } = e.target;

    this.setState(
      {
        notification: {
          ...this.state.notification,
          [name]: value,
        },
      },
      () => {
        // if user type changed, refresh audience count
        if (name === "userType") this._refreshAudienceCount();
      }
    );
  };

  _handleFilterChange = (e) => {
    const { name, value, type, checked } = e.target;
    const filterValue = type === "checkbox" ? checked : value;

    this.setState(
      {
        notification: {
          ...this.state.notification,
          filters: {
            ...this.state.notification.filters,
            [name]: filterValue,
          },
        },
      },
      () => {
        // ✅ refresh count when filters change
        this._refreshAudienceCount();
      }
    );
  };

  _safeErrorMessage = (err) => {
    if (!err) return "Something went wrong";
    if (typeof err === "string") return err;
    if (err?.message) return err.message;
    // FetchHelper might throw response with "error"/"detail"
    return err?.error || err?.detail || "Something went wrong";
  };

  _refreshAudienceCount = async () => {
    const { notification } = this.state;

    this.setState({ isLoadingAudience: true });
    try {
      const res = await Backend.previewNotificationAudience({
        userType: notification.userType,
        filters: notification.filters,
      });

      // depending on your API response
      const targetedUsers = res?.targetedUsers ?? res?.targeted_users ?? 0;

      this.setState({ targetedUsers: targetedUsers });
    } catch (e) {
      // don’t spam toast on every filter change
      console.log("Audience preview failed:", e);
    } finally {
      this.setState({ isLoadingAudience: false });
    }
  };

  _toggleConfirmModal = async () => {
    const { showConfirmModal } = this.state;

    // when opening modal, ensure count is fresh
    if (!showConfirmModal) {
      await this._refreshAudienceCount();
    }

    this.setState({ showConfirmModal: !showConfirmModal });
  };

  _useAISuggestion = () => {
    this.setState({
      notification: {
        ...this.state.notification,
        title: this.state.aiSuggestion.title,
        message: this.state.aiSuggestion.message,
      },
    });
    toast.info("AI content applied to form!");
  };

  _sendNotification = async () => {
    const { notification, isSending } = this.state;
    if (isSending) return;

    this.setState({ isSending: true });

    try {
      await Backend.sendNotification({
        title: notification.title,
        message: notification.message,
        userType: notification.userType,
        filters: notification.filters,
      });

      toast.success("Notification sent successfully!");
      this.setState({
        showConfirmModal: false,
        notification: { ...notification, title: "", message: "" },
      });
    } catch (e) {
      toast.error(this._safeErrorMessage(e));
    } finally {
      this.setState({ isSending: false });
    }
  };

  componentDidMount() {
    // initial audience preview
    this._refreshAudienceCount();
  }

  render() {
    const {
      notification,
      targetedUsers,
      showConfirmModal,
      aiSuggestion,
      isSending,
      isLoadingAudience,
    } = this.state;

    return (
      <div className="container">
        <div className="row">
          <div className="col-lg-8">
            <Card title="Notification Console" showHeader={true} showExport={false}>
              <div className="form-group">
                <label className="font-weight-bold">Notification Title</label>
                <input
                  type="text"
                  className="form-control"
                  name="title"
                  placeholder="e.g. Flash Sale Live! 🚀"
                  value={notification.title}
                  onChange={this._handleInputChange}
                />
              </div>

              <div className="form-group">
                <label className="font-weight-bold">Message Content</label>
                <textarea
                  className="form-control"
                  name="message"
                  rows="4"
                  placeholder="Draft your push notification message here..."
                  value={notification.message}
                  onChange={this._handleInputChange}
                />
                <span className="form-text text-muted">
                  Estimated character count: {notification.message.length}
                </span>
              </div>

              <div className="separator separator-dashed my-8"></div>

              <h5 className="mb-4">Audience Selection</h5>

              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label>User Type</label>
                    <select
                      className="form-control"
                      name="userType"
                      value={notification.userType}
                      onChange={this._handleInputChange}
                    >
                      <option value="All">All Users</option>
                      <option value="Customers">Customers</option>
                      <option value="Drivers">Drivers</option>
                      <option value="Vendors">Vendors</option>
                    </select>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="form-group">
                    <label>County</label>
                    <select
                      className="form-control"
                      name="county"
                      value={notification.filters.county}
                      onChange={this._handleFilterChange}
                    >
                      <option value="All">All Counties</option>
                      <option value="Cork">Cork</option>
                      <option value="Limerick">Limerick</option>
                      <option value="Dublin">Dublin</option>
                    </select>
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label>User Status</label>
                    <select
                      className="form-control"
                      name="status"
                      value={notification.filters.status}
                      onChange={this._handleFilterChange}
                    >
                      <option value="All">All</option>
                      <option value="Active">Active</option>
                      <option value="Inactive">Inactive</option>
                    </select>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="form-group">
                    <label>Last Order After</label>
                    <input
                      type="date"
                      className="form-control"
                      name="lastOrderDate"
                      value={notification.filters.lastOrderDate}
                      onChange={this._handleFilterChange}
                    />
                  </div>
                </div>
              </div>

              <div className="form-group row mt-4">
                <div className="col-md-6">
                  <label className="checkbox checkbox-lg checkbox-outline checkbox-success">
                    <input
                      type="checkbox"
                      name="isHighValue"
                      checked={notification.filters.isHighValue}
                      onChange={this._handleFilterChange}
                    />
                    <span></span>
                    High-value users only
                  </label>
                </div>

                {notification.userType === "Drivers" && (
                  <div className="col-md-6">
                    <label className="checkbox checkbox-lg checkbox-outline checkbox-primary">
                      <input
                        type="checkbox"
                        name="activeDeliveries"
                        checked={notification.filters.activeDeliveries}
                        onChange={this._handleFilterChange}
                      />
                      <span></span>
                      Drivers with active deliveries
                    </label>
                  </div>
                )}
              </div>

              <div
                className="alert alert-custom alert-light-primary fade show py-4 mb-5"
                role="alert"
              >
                <div className="alert-text font-weight-bold" style={{ color: "#73113b" }}>
                  Targeted Audience Size:{" "}
                  {isLoadingAudience ? "Calculating..." : `${targetedUsers} Users`}
                </div>
              </div>

              <button
                className="btn btn-primary btn-lg btn-block font-weight-bolder"
                onClick={this._toggleConfirmModal}
                disabled={!notification.title || !notification.message}
                style={{ background: "#73113b", border: "#73113b" }}
              >
                <i className="la la-paper-plane"></i> Send Push Notification Now
              </button>
            </Card>
          </div>

          <div className="col-lg-4">
            <Card title="AI Assistant (Preview)" showHeader={true} showExport={false}>
              <div className="d-flex flex-column h-100">
                <button
                  className="btn btn-light-primary font-weight-bold mb-6 py-4"
                  onClick={this._useAISuggestion}
                  style={{ color: "#73113b" }}
                >
                  <i className="la la-magic mr-2"></i>AI Generate Notification
                </button>

                <div className="bg-light p-6 rounded mb-auto">
                  <h6 className="font-weight-bolder mb-4 " style={{ color: "#73113b" }}>
                    Smart Suggestion:
                  </h6>
                  <div className="mb-4">
                    <label className="text-muted small font-weight-bold mb-1 uppercase">
                      Suggested Title
                    </label>
                    <p className="font-weight-bold">{aiSuggestion.title}</p>
                  </div>
                  <div className="mb-4">
                    <label className="text-muted small font-weight-bold mb-1 uppercase">
                      Suggested Message
                    </label>
                    <p className="small">{aiSuggestion.message}</p>
                  </div>
                  <div className="separator separator-dashed mb-4"></div>
                  <div className="mb-0">
                    <label className="text-muted small font-weight-bold mb-1 uppercase">
                      Best Time to Send
                    </label>
                    <p className="small text-success font-weight-bold">{aiSuggestion.bestTime}</p>
                  </div>
                </div>

                <button
                  className="btn btn-outline-primary font-weight-bold mt-6 py-3"
                  style={{ color: "#73113b", border: "1px solid #73113b" }}
                >
                  <i className="la la-users mr-2"></i>AI Suggest Audience
                </button>
              </div>
            </Card>
          </div>
        </div>

        <Modal show={showConfirmModal} onHide={this._toggleConfirmModal} centered>
          <Modal.Header closeButton>
            <Modal.Title className="text-primary font-weight-bolder">
              Confirm Push Notification
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <p className="font-size-h6 text-center">
              Are you sure you want to send this notification to{" "}
              <strong>{targetedUsers}</strong> users in{" "}
              <strong>{notification.filters.county}</strong>?
            </p>

            <div className="bg-light p-4 rounded border">
              <p className="mb-2 font-weight-bold text-dark">{notification.title}</p>
              <p className="mb-0 text-muted small">{notification.message}</p>
            </div>
          </Modal.Body>

          <Modal.Footer className="bg-light">
            <button className="btn btn-link-secondary font-weight-bold" onClick={this._toggleConfirmModal}>
              Cancel
            </button>
            <button
              className="btn btn-primary px-10 font-weight-bolder"
              onClick={this._sendNotification}
              disabled={isSending}
            >
              {isSending ? "Sending..." : "Yes, Send Now"}
            </button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}
